import React, { PropsWithChildren, useState } from 'react';

import { Grid, Icon, Surface, Text } from '@zapier/design-system';

import Accordion from 'app/common/components/Accordion';

const icons = {
  complete: {
    name: 'formCheckCircle' as const,
    color: 'StatusSuccess' as const,
    label: 'step is complete',
  },
  error: {
    name: 'alertCircleFill' as const,
    color: 'StatusError' as const,
    label: 'errors in this step',
  },
};

type Props = {
  isComplete: boolean;
  isError: boolean;
  isOpenInitially?: boolean;
  title: string;
};

function Step({
  children,
  isComplete,
  isError,
  title,
}: PropsWithChildren<Props>) {
  const [isOpen, setIsOpen] = useState(false);
  const icon = isError ? icons.error : isComplete ? icons.complete : null;

  return (
    <Surface borderColor="StrokeDefault">
      <Accordion
        isOpen={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
        title={
          <Grid columns="repeat(2, auto) 1fr" gap="10px">
            <Text fontWeight={600} type="Body4">
              {title}
            </Text>
            {icon && (
              <span aria-label={icon.label}>
                <Icon color={icon.color} name={icon.name} size={24} />
              </span>
            )}
          </Grid>
        }
      >
        {children}
      </Accordion>
    </Surface>
  );
}

export default Step;
